const map = {
	"./widgets/curatorReport/settings.vue": 18500,
	"./widgets/curatorReport/widget.vue": 14920,
	"./widgets/grades/settings.vue": 82510,
	"./widgets/grades/widget.vue": 84895,
	"./widgets/hyperlink/settings.vue": 35563,
	"./widgets/hyperlink/widget.vue": 51714,
	"./widgets/incoming/settings.vue": 69938,
	"./widgets/incoming/widget.vue": 81315,
	"./widgets/myCourses/settings.vue": 26866,
	"./widgets/myCourses/widget.vue": 52184,
	"./widgets/proCollegeInfo/settings.vue": 52386,
	"./widgets/proCollegeInfo/widget.vue": 91794,
	"./widgets/serverInfo/settings.vue": 90177,
	"./widgets/serverInfo/widget.vue": 47654,
	"./widgets/service/settings.vue": 70402,
	"./widgets/service/widget.vue": 80501,
	"./widgets/staffInfo/settings.vue": 20912,
	"./widgets/staffInfo/widget.vue": 97681,
	"./widgets/studentDebt/settings.vue": 23441,
	"./widgets/studentDebt/widget.vue": 33633,
	"./widgets/timetable/settings.vue": 74005,
	"./widgets/timetable/widget.vue": 49219,
	"./widgets/usefulLinks/settings.vue": 96960,
	"./widgets/usefulLinks/widget.vue": 2027
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47102;